import themes from '@8x8/oxygen-theme'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import styled, { ThemeContext } from 'styled-components'

import { Flex } from '~/components/common/containers'
import InfiniteList from '~/components/infinite-list'

import commonCss from '~/core/css'
import { getIsNarrowLayout } from '~/selectors/ui'
import SlideshowItem from './item'

const Container = styled.div`
  position: relative;
  ${({ orientation, theme }) => orientation === 'vertical'
? `
    border-right: 1px solid ${themes.dark.ui02};
    height: 100%;
    width: ${theme.sizes.slideshowVerticalSidebarWidth}px;
  `
: `
    border-top: 1px solid ${themes.dark.ui02};
    height: ${theme.sizes.slideshowHorizontalSidebarHeight}px;
    width: 100%;
  `};
`

const ListContainer = styled(Flex)`
  ${commonCss.resetBoxProps};
  list-style-type: none;

  ${({ orientation }) => orientation === 'vertical'
? `
    padding: 16px 16px 0 16px;
    flex-direction: column;
  `
: `
    padding: 16px 0 16px 16px;
  `};
`

const SlideshowList = ({
  fetchingInProgress,
  fetchMore,
  selectedSlide,
  slideNameMapping,
  slideProps,
  slides,
  SlideComponent
}) => {
  const theme = useContext(ThemeContext)
  const isNarrowLayout = useSelector(getIsNarrowLayout)
  const orientation = isNarrowLayout ? 'horizontal' : 'vertical'

  const slideWidth = (theme.sizes.slideshowHorizontalSidebarHeight - 32) * 16 / 9
  const slideHeight = (theme.sizes.slideshowVerticalSidebarWidth - 32) * 9 / 16

  return (
    <Container orientation={orientation}>
      <InfiniteList fetchMore={fetchMore} orientation={orientation} isFetching={fetchingInProgress}>
        <ListContainer orientation={orientation}>
          {slides.map((slide, index) => {
            const mappedSlideProps = {
              ...slideProps,
              [slideNameMapping]: slide
            }

            return (
              <SlideshowItem
                height={slideHeight}
                isSelected={slide === selectedSlide}
                key={`slide-${index}`}
                orientation={orientation}
                SlideComponent={SlideComponent}
                slideProps={mappedSlideProps}
                width={slideWidth}
              />
            )
          })}
        </ListContainer>
      </InfiniteList>
    </Container>
  )
}

export default SlideshowList
